import { LegalDocumentPage } from "./LegalDocumentPage";

export const PrivacyPage = () => <LegalDocumentPage document="PRIVACY" />;
